/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import DropDownList from '../../components/DropDownList';
import { fullPathSelector } from '../../selectors/RouterSelector';
import { evaluateModelInstance, clearModelInstance } from '../../actions/EvaluationActions';

import './InstanceEvaluation.sass';

function rleToMask(data, h, w) {
  const m = data.length;
  let arr = new Array(h);
  for (let i = 0; i < arr.length; i++) {
    arr[i] = new Array(w);
  }

  let v = 0;
  let idx = 0;
  for (let j = 0; j < m; j++) {
    for (let k = 0; k < data[j]; k++) {
        let x = Math.floor(idx / h);
        let y = idx % h;
        arr[y][x] = v;
        idx++;
    }
    v = 255 - v;
  }

  return arr;
}

class InstanceEvaluation extends Component {
  constructor(props) {
    super(props);
    this.handleSwitchToSegmentationPage = this.handleSwitchToSegmentationPage.bind(this);
    this.handleSelectModel = this.handleSelectModel.bind(this);
    this.handleToggleInstance = this.handleToggleInstance.bind(this);

    this.state = {
      selected: { title: 'Select Model', value: 0 },
      selectedInstances: [],
    };
  }

  componentDidMount() {
    this.props.dispatch(clearModelInstance());
    this.resetCanvas();
  }

  handleSwitchToSegmentationPage() {
    const { history } = this.props;
    const fullPath = fullPathSelector(this.props);
    history.push(fullPath.replace(/\/evaluation/, '/segmentation'));
  }

  handleSelectModel({ title, value }) {
    const { dispatch, sn } = this.props;
    this.setState({
      selected: { title, value },
      selectedInstances: []
    });

    dispatch(evaluateModelInstance({ modelSn: value, imageSn: sn }));
    this.resetCanvas();
  }

  async handleToggleInstance(instance) {
    const { selectedInstances } = this.state;
    const index = selectedInstances.findIndex(i => i.sn === instance.sn);
    if (index === -1) {
      /* Append instance */
      this.setState({
        selectedInstances: [...this.state.selectedInstances, instance]
      });
      this.drawSingleMask(instance);
    } else {
      /* Delete instance */
      this.resetCanvas();
      const newInstances = [...selectedInstances];
      newInstances.splice(index, 1);
      await this.setState({
        selectedInstances: newInstances
      });
      this.drawAllMask();
    }
  }
  
  resetCanvas() {
    const { canvas } = this;
    const { width, height } = this.props;
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = 'rgba(0, 0, 0, 0.75)';
    ctx.fillRect(0, 0, width, height);
  }

  drawAllMask() {
    const { selectedInstances } = this.state;
    selectedInstances.forEach(instance => {
      this.drawSingleMask(instance);
    });
  }

  drawSingleMask(instance) {
    const { width, height } = this.props;
    const greyscale = rleToMask(instance.seg, height, width);
    const { canvas } = this;
    const ctx = canvas.getContext('2d');

    for(let gj = 0; gj < greyscale.length; gj++){
      for(let gk = 0; gk < greyscale[0].length; gk++){
        let isWhite = greyscale[gj][gk] === 255;
        if (isWhite) {
          ctx.clearRect(gk, gj, 1, 1);  
        }
      }
    }
  }

  render() {
    const {
      url,
      width,
      height,
      models,
      instanceMapping
    } = this.props;
    const { selected, selectedInstances } = this.state;
    const categories = [...instanceMapping.keys()];

    return (
      <div className="InstanceEvaluation">
        <section className="evaluation-image">
          <img src={url} />

          <div className="canvas-wrapper">
            <canvas
              width={width}
              height={height}
              ref={(c) => { this.canvas = c; }}
            />
          </div>
        </section>

        <div className="control-panel">
          <div className="control-panel-tabs">
            <button onClick={this.handleSwitchToSegmentationPage}>Ground Truth</button>
            <button className="active">Evaluation</button>
          </div>

          <div className="dropdown-list-wrapper">
            <DropDownList
              title="Selected Model"
              options={models}
              selected={selected}
              width={200}
              onSelect={this.handleSelectModel}
            />

            <div className="instance-list">
              {
                categories.map(name => (
                  <div key={name} className="instance-list-item">
                    <p className="title">{name}</p>
                    {
                      instanceMapping.get(name).map(instance => (
                        <button
                          key={instance.sn}
                          className={selectedInstances.find(i => i.sn === instance.sn) ? 'active' : ''}
                          onClick={() => this.handleToggleInstance(instance)}
                        >
                          {instance.sn}
                        </button>
                      ))
                    }
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

InstanceEvaluation.propTypes = {
  sn: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  // source: PropTypes.string,
  // ext: PropTypes.string,
  // jumboid: PropTypes.string,
  // timestamp: PropTypes.number,
  // batch: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  // query: PropTypes.string.isRequired,
  // history: PropTypes.object.isRequired
  models: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.number
  })).isRequired,
  // instances: PropTypes.arrayOf(PropTypes.shape({
  //   area: PropTypes.number,
  //   box: PropTypes.arrayOf(PropTypes.number),
  //   confidence: PropTypes.number,
  //   encoding: PropTypes.oneOf(['rle', 'bbox', 'seg']),
  //   image_sn: PropTypes.number,
  //   model_sn: PropTypes.number,
  //   seg: PropTypes.arrayOf(PropTypes.number),
  //   sn: PropTypes.number,
  //   umbo_category_name: PropTypes.string,
  //   umbo_category_sn: PropTypes.number
  // })),
  instanceMapping: PropTypes.any.isRequired
};

function mapStateToProps(store) {
  const {
    SearchParameter: { models, modelMap },
    Evaluation: { evaluationInstances: instances }
  } = store;
  const modelReshaped = models.available.map(name => ({ title: name, value: modelMap.get(name) }));

  const categories = [
    ...instances.reduce(
      (acc, instance) => acc.add(instance.umbo_category_name),
      new Set()
    )
  ];

  const instanceMapping = new Map();
  categories.forEach(category => {
    instanceMapping.set(category, []);
  });

  instances.forEach(instance => {
    instanceMapping.get(instance.umbo_category_name).push(instance);
  });

  return {
    models: modelReshaped,
    instanceMapping
  };
}

export default withRouter(connect(mapStateToProps)(InstanceEvaluation));



// WEBPACK FOOTER //
// ./src/containers/Main/InstanceEvaluation.jsx